export const calcCropInfo = (croppedArea, croppedAreaPixels, sourceImage) => {
  let cropInfo = {
    percent: croppedArea,
    pixels: croppedAreaPixels
  };
  if (sourceImage) {
    let {
      x,
      y,
      width,
      height
    } = croppedArea;
    x = sourceImage.size.width / 100 * x;
    y = sourceImage.size.height / 100 * y;
    width = sourceImage.size.width / 100 * width;
    height = sourceImage.size.height / 100 * height;
    cropInfo.sourceImage = {
      x: Math.round(x),
      y: Math.round(y),
      width: Math.round(width),
      height: Math.round(height),
      TopLeftX: Math.round(x),
      BottomRightY: Math.round(y + height),
      BottomRightX: Math.round(x + width),
      TopLeftY: Math.round(y)
    };
  }
  return cropInfo;
};
export const calcAreaFromSource = (sourceImage, mediaSize) => {
  var _sourceImage$crop, _sourceImage$crop2, _sourceImage$crop3, _sourceImage$crop4, _sourceImage$crop5, _sourceImage$crop6, _sourceImage$crop7, _sourceImage$crop8;
  const heightRatio = (mediaSize.naturalHeight ? mediaSize.naturalHeight : mediaSize.height) / sourceImage.size.height;
  const widthRatio = (mediaSize.naturalWidth ? mediaSize.naturalWidth : mediaSize.width) / sourceImage.size.width;
  const topLeftX = (_sourceImage$crop = sourceImage.crop) !== null && _sourceImage$crop !== void 0 && _sourceImage$crop.TopLeftX ? (_sourceImage$crop2 = sourceImage.crop) === null || _sourceImage$crop2 === void 0 ? void 0 : _sourceImage$crop2.TopLeftX : 0;
  const topLeftY = (_sourceImage$crop3 = sourceImage.crop) !== null && _sourceImage$crop3 !== void 0 && _sourceImage$crop3.TopLeftY ? (_sourceImage$crop4 = sourceImage.crop) === null || _sourceImage$crop4 === void 0 ? void 0 : _sourceImage$crop4.TopLeftY : 0;
  const bottomRightX = (_sourceImage$crop5 = sourceImage.crop) !== null && _sourceImage$crop5 !== void 0 && _sourceImage$crop5.BottomRightX ? (_sourceImage$crop6 = sourceImage.crop) === null || _sourceImage$crop6 === void 0 ? void 0 : _sourceImage$crop6.BottomRightX : 0;
  const bottomRightY = (_sourceImage$crop7 = sourceImage.crop) !== null && _sourceImage$crop7 !== void 0 && _sourceImage$crop7.BottomRightY ? (_sourceImage$crop8 = sourceImage.crop) === null || _sourceImage$crop8 === void 0 ? void 0 : _sourceImage$crop8.BottomRightY : 0;
  const area = {
    height: (sourceImage.size.height - topLeftY - (sourceImage.size.height - bottomRightY)) * heightRatio,
    width: (sourceImage.size.width - topLeftX - (sourceImage.size.width - bottomRightX)) * widthRatio,
    x: topLeftX * widthRatio,
    y: topLeftY * heightRatio
  };
  return area;
};